import { ErroDaApi } from "./erro-da-api";

/**
 * Mensagem para o usuario a partir do codigo do Problem Details. A API manda
 * mensagem tecnica e sem acento; aqui ela vira texto de produto.
 */
const MENSAGEM_POR_CODIGO: Readonly<Record<string, string>> = {
  "credenciais-invalidas":
    "E-mail ou senha incorretos. Depois de várias tentativas o acesso fica bloqueado por 15 minutos.",
  "link-de-senha-invalido": "Este link é inválido ou expirou. Peça um novo.",
  "email-ja-cadastrado": "Já existe um usuário com este e-mail.",
  "ultimo-administrador": "O sistema precisa de ao menos um administrador ativo.",
  "alteracao-da-propria-conta": "Você não pode desativar nem rebaixar a sua própria conta.",
  "pessoa-ja-vinculada": "Esta pessoa já tem acesso a este cliente.",
  "equipe-monte-nao-precisa-de-vinculo": "Quem é da equipe Monte já acessa todos os clientes.",
  "cliente-nao-encontrado": "Este cliente não existe ou você não tem acesso a ele.",
  "vinculo-nao-encontrado": "Esta pessoa não tem mais acesso a este cliente.",
  "administrador-nao-pode-ser-excluido":
    "Quem é da equipe Monte não pode ser excluído. Remova da equipe Monte antes.",
  "token-do-kommo-recusado":
    "O Kommo recusou o token. Gere um novo token de longa duração na integração privada e tente de novo.",
  "conta-do-kommo-nao-encontrada": "Não encontramos essa conta no Kommo. Confira o endereço, como em suaclinica.kommo.com.",
  "sincronizacao-em-andamento": "Já existe uma sincronização em andamento. Aguarde ela terminar.",
  "etapa-inexistente-no-kommo": "Uma das etapas escolhidas não existe mais no Kommo. Escolha de novo.",
  "sem-permissao-para-configurar": "Somente a equipe Monte ou o gestor da clínica configuram as conexões.",
  "sem-permissao-para-acessos": "Somente a equipe Monte ou o gestor da clínica gerenciam os acessos.",
  "alteracao-do-proprio-acesso": "Você não pode alterar nem remover o seu próprio acesso. Peça a outro gestor ou à equipe Monte.",
  "token-do-meta-recusado": "O Meta recusou o token. Gere um novo no Business Manager e salve de novo.",
  "credencial-meta-ausente": "A equipe Monte ainda não configurou o acesso ao Meta Ads.",
  "chave-de-ia-recusada": "A OpenAI recusou a chave. Confira e tente de novo.",
  "chave-de-ia-ausente": "A chave da OpenAI ainda não foi salva em Conexões.",
  "leitura-da-ia-indisponivel": "A OpenAI não respondeu agora. Tente de novo em alguns minutos.",
  "conta-de-anuncio-inacessivel": "Uma das contas de anúncio não está acessível com o token da Monte.",
  "sem-permissao-para-midia": "Você não tem permissão para alterar essa configuração.",
  "sincronizacao-de-midia-em-andamento": "Já existe uma sincronização do Meta em andamento. Aguarde ela terminar.",
  "limite-excedido": "Muitas tentativas em pouco tempo. Aguarde um minuto e tente de novo.",
  validacao: "Revise os campos informados.",
};

export function mensagemDoErro(erro: unknown): string {
  if (!(erro instanceof ErroDaApi)) return "Algo deu errado. Tente de novo.";
  if (erro.status === 0) return "Não foi possível falar com o servidor. Verifique a conexão.";
  const campos = Object.values(erro.campos).flat();
  if (campos.length > 0) return campos.join(" ");
  const codigo = erro.problema?.type.split("/").at(-1) ?? "";
  if (erro.status >= 500) {
    return erro.requestId
      ? `A Central não conseguiu montar os dados. Código ${erro.requestId}.`
      : "A Central não conseguiu montar os dados. Tente de novo.";
  }
  if (!erro.problema && erro.message.includes("nao corresponde ao contrato")) {
    return "A Central veio num formato que esta tela não reconhece. Atualize a página.";
  }
  return MENSAGEM_POR_CODIGO[codigo] ?? "Algo deu errado. Tente de novo.";
}
